export const xsScroll = () => {
    const topNavXs = document.querySelector('#top-nav-xs');
    if(topNavXs){
        const logoMobile = document.querySelector('#logo-mobile');
        const navIcon = document.querySelectorAll('.nav-icon');
        if(document.documentElement.scrollTop > topNavXs.clientHeight || document.body.scrollTop > topNavXs.clientHeight){
            topNavXs.classList.add('scrolled');
            topNavXs.classList.add('shadow');
            logoMobile.src = '/img/png/logo-original.png';
            navIcon.forEach((icon)=>{
                icon.classList.add('text-dark');
                icon.classList.remove('text-light');
            });
        }
        else{
            topNavXs.classList.remove('scrolled');
            topNavXs.classList.remove('shadow');
            logoMobile.src = '/img/png/logo-light.png';
            navIcon.forEach((icon)=>{
                icon.classList.add('text-light');
                icon.classList.remove('text-dark');
            });
        }
    }
}
// export {navigation};